<template>
  <div class="policy-card" :class="{ active: selected }" @click="$emit('click', policy)">
    <div class="card-header">
      <span class="policy-name van-ellipsis">{{ policy.policyName }}</span>
      <span class="policy-tag van-ellipsis" :class="policy.tagType">{{ policy.modality === 0 ? $t('shared.onSite') : policy.modality === 1 ? $t('shared.offSite') : policy.modality === 2 ? $t('shared.webSite') : '' }}</span>
    </div>

    <div class="info-row">
      <span class="label">{{ $t('shared.applicable') }}: </span>
      <span v-for="(prod, index) in policy.policyProductList" :key="index" class="product-tag" :style="{border: `1px solid ${prod.productColor}`, color: prod.productColor}">{{ prod.productName }}</span>
    </div>

    <!-- 只有在列表页（非选中展示页）才可能折叠/展开，或者始终展示 -->
    <!-- 根据UI图1，选中后展示了详细规则。图2也有规则。 -->
    <div class="rules-section">
      <div class="rules-header" @click.stop="toggleRules">
        <div class="time-range">
          {{ policy.startTime }}~{{ policy.endTime }}
        </div>
        <div v-if="collapsible">
          <span v-if="!showRules" class="rules-toggle">{{ $t('shared.rules') }} <van-icon name="arrow-down" /></span>
          <span v-else class="rules-toggle">{{ $t('shared.rules') }} <van-icon name="arrow-up" /></span>
        </div>
      </div>

      <div class="rules-content" v-if="!collapsible || showRules">
        <div class="rule-line" v-if="policy.days">{{ $t('shared.titleEight', { days: policy.days }) }}</div>
        <div class="rule-line" v-if="policy.reportType === 1">{{ $t('shared.titleNine') }}.</div>
        <div class="rule-line" v-else-if="policy.reportType === 2">{{ $t('shared.titleTen') }}.</div>
        <div class="rule-title" v-if="policy.newPlanList && policy.newPlanList.length">{{ $t('shared.eventPolicy') }}:</div>
        <div class="rule-item" v-for="(rule, idx) in policy.newPlanList" :key="idx">• {{ rule }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyCard',
  props: {
    policy: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    collapsible: {
      // 是否可以折叠规则
      type: Boolean,
      default: false
    },
    initShowRules: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showRules: this.initShowRules
    }
  },
  methods: {
    toggleRules () {
      if (!this.collapsible) return
      this.showRules = !this.showRules
    }
  }
}
</script>

<style lang="less" scoped>
.policy-card {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid transparent;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  margin-bottom: 10px;

  &.active {
    // border-color: #f0f7ff; // Vant Blue
    // background-color: #f0f7ff;
  }

  .card-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .policy-name {
      max-width: 260px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-right: 8px;
    }

    .policy-tag {
      max-width: 60px;
      font-size: 10px;
      padding: 2px 6px;
      border-radius: 2px;
      color: #fff;
      background-color: #f59a23;
    }
  }

  .info-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;

    .label {
      font-size: 12px;
      color: #666;
      margin-right: 4px;
    }
    .product-tag {
      font-size: 12px;
      padding: 0 4px;
      border: 1px solid #ddd;
      margin-right: 4px;
      margin-bottom: 2px;
      border-radius: 2px;
      line-height: 13.5px;
    }
  }

  .rules-section {
    font-size: 12px;
    color: #999;

    .rules-header {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 6px 0;
      color: #999;
      border-top: 1px solid #f5f5f5;
    }

    .rules-content {
      .rule-title {
        margin: 4px 0;
      }

      .rule-item {
        color: #999;
        line-height: 1.4;
      }
    }
  }
}
</style>
